(() => {
  if (window.__raMobileMenuPremiumInitialised) return;
  window.__raMobileMenuPremiumInitialised = true;

  const DRAWER_SELECTOR = '#m-menu-drawer';
  const LABEL_SELECTOR = '.ra-menu-overlabel, .ra-menu-new-badge, .ra-menu-best-seller-badge';
  let frame = 0;

  const normalize = (value) => (value || '')
    .replace(/\uFE0F/g, '')
    .replace(/🔥/g, '')
    .replace(/\s+/g, ' ')
    .trim()
    .toLocaleLowerCase('it-IT');

  const getVisibleLinkText = (link) => {
    const clone = link.cloneNode(true);
    clone.querySelectorAll(LABEL_SELECTOR).forEach((badge) => badge.remove());
    return normalize(clone.textContent);
  };

  const removeFireEmoji = (link) => {
    const walker = document.createTreeWalker(link, NodeFilter.SHOW_TEXT);
    const textNodes = [];

    while (walker.nextNode()) textNodes.push(walker.currentNode);

    textNodes.forEach((node) => {
      if (node.parentElement?.closest(LABEL_SELECTOR)) return;
      const cleaned = node.textContent
        .replace(/\uFE0F/g, '')
        .replace(/🔥/g, '')
        .replace(/\s{2,}/g, ' ');
      if (cleaned !== node.textContent) node.textContent = cleaned;
    });
  };

  const ensureTitleAnchor = (link) => {
    const current = Array.from(link.children).find((child) =>
      child.matches?.('.ra-menu-title-anchor')
    );
    if (current) return current;

    const directTitleSpan = Array.from(link.children).find((child) =>
      child.matches?.('span:not(.ra-menu-overlabel):not(.ra-menu-new-badge):not(.ra-menu-best-seller-badge)') &&
      normalize(child.textContent)
    );

    if (directTitleSpan) {
      directTitleSpan.classList.add('ra-menu-title-anchor');
      return directTitleSpan;
    }

    const textNodes = Array.from(link.childNodes).filter((node) =>
      node.nodeType === Node.TEXT_NODE && normalize(node.textContent)
    );
    if (!textNodes.length) return null;

    const anchor = document.createElement('span');
    anchor.className = 'ra-menu-title-anchor';
    textNodes[0].before(anchor);
    textNodes.forEach((node) => anchor.appendChild(node));
    return anchor;
  };

  const addOverlabel = (link, item, text, variant) => {
    const anchor = ensureTitleAnchor(link);
    if (!anchor) return;

    const label = document.createElement('span');
    label.className = `ra-menu-overlabel ra-menu-overlabel--${variant}`;
    label.textContent = text;
    label.setAttribute('aria-hidden', 'true');
    anchor.appendChild(label);
    item.classList.add('ra-menu-has-overlabel');
  };

  const enhanceDrawer = (scope = document) => {
    const drawer = scope.matches?.(DRAWER_SELECTOR)
      ? scope
      : scope.querySelector?.(DRAWER_SELECTOR) || document.querySelector(DRAWER_SELECTOR);
    if (!drawer) return;

    const navigation = drawer.querySelector('.m-menu-drawer__navigation');
    if (!navigation) return;

    Array.from(navigation.children).forEach((item) => {
      if (!item.classList?.contains('m-menu-mobile__item')) return;

      const link = Array.from(item.children).find((child) => child.matches?.('.m-menu-mobile__link'));
      if (!link) return;

      const title = getVisibleLinkText(link);
      item.classList.remove(
        'ra-menu-new-arrivals',
        'ra-menu-best-seller',
        'ra-menu-has-overlabel',
        'ra-menu-section-heading'
      );
      link.querySelectorAll(LABEL_SELECTOR).forEach((badge) => badge.remove());

      if (title === 'nuovi arrivi') {
        removeFireEmoji(link);
        item.classList.add('ra-menu-new-arrivals');
        addOverlabel(link, item, 'NEW', 'new');
      }

      if (title === 'code extension') {
        item.classList.add('ra-menu-best-seller');
        addOverlabel(link, item, 'BEST SELLER', 'best');
      }

      if (title === 'shop per categoria') {
        item.classList.add('ra-menu-section-heading');
      }
    });

    drawer.dataset.raPremiumMenuReady = 'true';
  };

  const scheduleEnhance = (scope = document) => {
    window.cancelAnimationFrame(frame);
    frame = window.requestAnimationFrame(() => enhanceDrawer(scope));
  };

  const start = () => scheduleEnhance(document);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  window.addEventListener('load', start, { once: true });
  window.addEventListener('pageshow', start);
  document.addEventListener('shopify:section:load', (event) => scheduleEnhance(event.target));

  const observer = new MutationObserver((mutations) => {
    const drawerAdded = mutations.some((mutation) =>
      Array.from(mutation.addedNodes).some((node) =>
        node.nodeType === Node.ELEMENT_NODE && (
          node.matches?.(DRAWER_SELECTOR) ||
          node.querySelector?.(DRAWER_SELECTOR)
        )
      )
    );

    if (drawerAdded) scheduleEnhance(document);
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
